import moment from "moment";

import "./defineNl";

// import moment from "moment/min/moment.min";
// TODO: make use of moment instead of moment-with-locales to only load needed locales

// moment.defineLocale("nl", nlLocale);

export const DATE_FNS_FORMATS = {
  DATE_TIME: "yyyy-MM-dd HH:mm:ss",
};

export const DATE_FORMATS = {
  DATE_TIME: "YYYY-MM-DD HH:mm:ss",
  DATE: "YYYY-MM-DD",
  TIME: "HH:mm:ss",
  UTC: "M-DD-YY h:m:s a",
  BUMBAL: "YYYY-MM-DD HH:mm:ss",
  JS: "js",
  MOMENT: "moment",

  SIMPLE: "DDMMYYYY",

  HUMAN_READABLE_FULL: "DD-MM-YYYY HH:mm",
  HUMAN_READABLE_DATE: "DD-MM-YYYY",
  HUMAN_READABLE_TIME: "HH:mm",

  WRITTEN_DATE: "DD MMMM YYYY",

  JARPIS: "M-DD-YY, h:m:s a",
};

export function setMomentLocale(locale) {
  moment.locale(locale);
}

/**
 * Parse a date into a moment object and return the formatted string
 */
export function format(
  locale,
  outputFormat,
  date,
  inputFormat = DATE_FORMATS.DATE_TIME,
) {
  const momentDate = parse(date, inputFormat);
  return momentDate.locale(locale).format(outputFormat);
}

/**
 * Parse a date into a moment object
 * @return {moment}
 */
export function parse(date, inputFormat) {
  // We shouldn't use an input format for objects like the js date or moment
  let momentDate = null;
  if (typeof date === "object" || !inputFormat) {
    momentDate = moment(date);
  } else {
    momentDate = moment(date, inputFormat);
  }
  return momentDate;
}

/**
 * Take a moment date and round the amount of minutes to the nearest multiple of n.
 * returns a copy, without modifying the original date.
 */
export function roundMinutes(date, n = 5) {
  const minutes = date.minutes();
  return date.clone().minutes(Math.round(minutes / n) * n);
}

/**
 * Round an amount of hours to the nearest multiple of n.
 * Decimal values are permitted.
 */
export function roundMinutesNumber(hours, n = 5) {
  return Math.round(hours / n) * n;
}

/**
 * Get the maximum date a treatment can be planned in.
 * @return {Moment} the maximum date.
 */
export function getMaxDate() {
  return moment()
    .add(4, "months")
    .add(1, "week");
}

export function isOutOfMax(date) {
  const max = getMaxDate();
  return date.isAfter(max, "weeks");
}

/**
 * Some preset components with predefined input formats
 */
export function formatDateTime(locale, outputFormat, date) {
  return format(locale, outputFormat, date, DATE_FORMATS.DATE_TIME);
}

export function formatDate(locale, outPutFormat, date) {
  return format(locale, outPutFormat, date, DATE_FORMATS.DATE);
}

export function formatTime(locale, outPutFormat, date) {
  return format(locale, outPutFormat, date, DATE_FORMATS.TIME);
}
